require('./bootstrap');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

require('jquery-ui/ui/widgets/datepicker.js');
require('jquery-ui/ui/widgets/dialog.js');
require('jquery-ui/ui/widgets/autocomplete.js');

require('./timepicker');

// require('bootstrap/dist/js/bootstrap.min');
window.moment = require('moment/moment');

/**
 \====================================================================
 \ NOTY
 \====================================================================
 */
window.Noty = require('noty');
Noty.overrideDefaults({
    layout: 'topRight',
    theme : 'nest',
});

/**
 \====================================================================
 \ SWEETALERT
 \====================================================================
 */
window.Swal = require('sweetalert2');

/**
 \====================================================================
 \ DROPZONE
 \====================================================================
 */
window.Dropzone = require('dropzone');
window.Dropzone.autoDiscover = false;

window.levenshtein = require('js-levenshtein');

window.sanitizeXSS = function(string) {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        "/": '&#x2F;',
    };
    const reg = /[&<>"'/]/ig;
    return string.replace(reg, (match)=>(map[match]));
  }

//error 419 happens usually for expired session, reload page to go to login
$(document).ajaxError(function(e, jqxhr) {
    if (jqxhr.status === 419) window.location.reload();
});
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 419) {
            window.location.reload();
        } else {
           return Promise.reject(error);
        }
    }
);

/**
 * Fix when sweetalert used on top of bootstrap modal.
 * Call first one before open.
 * Call Second one after close.
 */
window.fixBootstrapModal = function () {
    let modalNode = document.querySelector('.modal[tabindex="-1"]');
    if (!modalNode) return;

    modalNode.removeAttribute('tabindex');
    modalNode.classList.add('js-swal-fixed');
};

window.restoreBootstrapModal = function () {
    var modalNode = document.querySelector('.modal.js-swal-fixed');
    if (!modalNode) return;

    modalNode.setAttribute('tabindex', '-1');
    modalNode.classList.remove('js-swal-fixed');
}
Swal = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-sm btn-success px-3 mr-2',
        cancelButton: 'btn btn-sm btn-danger px-3',
        denyButton: 'btn btn-sm btn-warning px-3 mr-2',
        title: 'justify-content-start w-100',
        actions: 'justify-content-end'
    },
    showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
    },
    hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
    },
    buttonsStyling: false,
    willOpen: fixBootstrapModal,
    didDestroy: restoreBootstrapModal
});

/**
 \====================================================================
 \ FLATPICKR (datepicker)
 \====================================================================
 */
window.flatpickr = require('flatpickr');

/**
 \====================================================================
 \ FullCalendar
 \====================================================================
 */
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';

window.FullCalendar = Calendar;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;
window.bootstrapPlugin = bootstrapPlugin;

window.WorkPlan = {};

require('select2/dist/js/select2.full.min');
require('./bootstrap-switch.min');
require('./bootstrap-tokenfield.min');
require('./bootstrap-editable.min');
require('./classie');
require('jquery-mask-plugin');
require('./jquery.stickytableheaders.min');
require('./formatter/phoneNumberFormatter');
require('./selectFx');
require('bootstrap-select')
require('./notifications/header-messages');

require('./main');

require('./sidebar');
require('./campaign-cadence/report');

/**
 \====================================================================
 \ File inputs
 \====================================================================
 */
;(function( $, window, document, undefined ) {
    $('.inputfile').each( function() {
        let $input	 = $( this ),
            $label	 = $input.next('label'),
            labelVal = $label.html();

        $input.on('change', function(e) {
            let fileName = '';

            if (this.files && this.files.length > 1)
                fileName = (this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length);
            else if ( e.target.value )
                fileName = e.target.value.split( '\\' ).pop();

            if (fileName)
                $label.find('span:first-child').html(fileName);
            else
                $label.html(labelVal);
        });

        // Firefox bug fix
        $input
            .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
            .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
    });

    $('[data-toggle=popover]').popover();
    $('[data-bs-toggle=popover]').popover();

    // handle unauthenticated or CSRF token mismatch errors globally
    $( document ).ajaxError(function( event, jqxhr) {
        if(jqxhr.status === 401 || jqxhr.status === 419) {
            window.location.href = '/login';
        }
    });
})(jQuery, window, document);

